import { Error } from '../../global-types/services';
import { ErrorType } from '../../global-types/addresses';

/** Prefer a recognized USPS code, falling back to the reason carried in description. */
export const getAddressErrorType = (error?: Error): ErrorType | undefined =>
  Object.values(ErrorType).find((reason) => reason === error?.code) ??
  Object.values(ErrorType).find((reason) => reason === error?.description);

/**
 *
 * @param errors Array of errors given in the address response
 * @returns Address error
 */
export const getAddressError = (errors: Error[]) =>
  errors.find((error) => {
    return error.field === 'address';
  });
